import React from "react";
import { Loader2, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button as ShadButton } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// extends shadcn Button · radius 0 · Poppins 500 · sizes sm 28 / default 30 / md 36 / touch 44 / icon 30×30
const VARIANTS = {
  primary: "bg-primary text-primary-foreground hover:bg-primary-hover",
  secondary: "bg-card text-foreground border border-border hover:bg-muted",
  "outline-strong": "bg-card text-foreground border border-foreground hover:bg-muted",
  ghost: "bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground",
  destructive: "bg-destructive text-white hover:brightness-95",
  link: "bg-transparent text-primary hover:underline px-0",
};
const SIZES = { sm: "h-ctl-sm px-2.5 text-ui-xs", default: "h-ctl px-3 text-ui-sm", md: "h-ctl-md px-4 text-ui-base", touch: "h-ctl-touch px-4 text-ui-base", icon: "h-ctl w-[30px] p-0" };

export const Button = React.forwardRef(function Button({ variant = "secondary", size = "default", loading = false, icon: Icon, label, split, className, children, disabled, ...rest }, ref) {
  const content = (
    <ShadButton ref={ref} variant="ghost" disabled={disabled || loading} aria-label={size === "icon" ? label : undefined}
      className={cn("rounded-chip font-display font-medium inline-flex items-center gap-1.5 transition-colors duration-120 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
        VARIANTS[variant], SIZES[size], className)} {...rest}>
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : Icon ? <Icon className="w-4 h-4" /> : null}
      {size !== "icon" && children}
      {split && <ChevronDown className="w-3.5 h-3.5 -mr-0.5" />}
    </ShadButton>
  );
  if (size !== "icon" || !label) return content;
  return (
    <TooltipProvider delayDuration={300}><Tooltip><TooltipTrigger asChild>{content}</TooltipTrigger><TooltipContent className="text-ui-xs">{label}</TooltipContent></Tooltip></TooltipProvider>
  );
});
